import {
  getActionApprovalDocs,
  getContactsForAccount,
  getJointAccountHolderActionApprovalDoc,
} from '../../graphql/queries';
import {
  GET_APPROVAL_DOCS_REQUESTED,
  GET_APPROVAL_DOCS_COMPLETED,
  GET_APPROVAL_DOCS_FAILED,
} from './types';
import api from '../../services/api';
import debug from '../../services/debug';

// https://docs.amplify.aws/lib/graphqlapi/getting-started/q/platform/js#enable-queries-mutations-and-subscriptions
// https://docs.amplify.aws/cli/graphql-transformer/dataaccess
const getApprovalDocsAction = (ContactID) => async (dispatch) => {
  dispatch({
    type: GET_APPROVAL_DOCS_REQUESTED,
  });
  try {
    // This could (and should) be combined into a single query. Need to dig into AWS docs to see if it's possible to do this using the generated queries
    // rather than having to rely on custom written ones.
    const [
      {
        data: {
          getActionApprovalDocs: { items: docs },
        },
      },
      {
        data: {
          getContactsForAccount: { items: contacts },
        },
      },
    ] = await Promise.all([
      api.graphql({
        query: getActionApprovalDocs,
        variables: {
          ContactID,
        },
      }),
      api.graphql({
        query: getContactsForAccount,
        variables: {
          ContactID,
        },
      }),
    ]);

    const partnerDocsResults = await Promise.all(
      docs.map((doc) =>
        api.graphql({
          query: getJointAccountHolderActionApprovalDoc,
          variables: {
            ContactID,
            DocumentRepository: doc.DocumentRepository,
            DocFileName: doc.DocFileName,
          },
        }),
      ),
    );

    const partnerDocs = partnerDocsResults
      .flat()
      .map(({ data }) => data.getJointAccountHolderActionApprovalDoc);

    dispatch({
      type: GET_APPROVAL_DOCS_COMPLETED,
      payload: {
        contacts,
        docs,
        partnerDocs,
      },
    });
  } catch (err) {
    debug(GET_APPROVAL_DOCS_FAILED, err);

    dispatch({
      type: GET_APPROVAL_DOCS_FAILED,
      payload: err,
    });
  }
};

export default getApprovalDocsAction;
